import createStore from './store';
import { FormattedDefaultTranscript } from '@/player-config/src/types/transcript-types';

// TODO: @Hardik - To remove this store
export const fullTranscriptStore = createStore<FormattedDefaultTranscript>([]);
